import React from 'react';
import { ClaimTabProps } from '../claim-registration';
import { useTranslation } from 'react-i18next';
import LossDetails from './loss-details';
import { Button, Form } from 'antd';
import ClaimBinderDetails from './claim-binder-details';
import ProgramRIConsiderations from './program-ri-considerations';
import Comments from './comments';
import BinderClaimsFinanacialSummary from './binder-claims-financial-summary';

const BinderClaimsActions: React.FC<ClaimTabProps> = ({
  claim,
  includeNext,
  includeBack,
  navigateNext,
  navigateBack,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleClose = () => {
    // TODO: Implement close functionality
  };

  const handleSave = () => {
    // TODO: Implement save functionality
  };

  const handlePaymentReserveChange = () => {
    // TODO: Implement payment/reserve change functionality
  };

  return (
    <Form
      form={form}
      layout="vertical"
      className="space-y-8"
      initialValues={{}}
      onFinish={() => {}}
      onValuesChange={() => {}}
    >
      <LossDetails />

      <ClaimBinderDetails />

      <ProgramRIConsiderations />

      <BinderClaimsFinanacialSummary />

      <Comments />

      <div className="flex flex-col sm:flex-row gap-2">
        <Button
          className="w-full rounded-[12px] h-12 text-base font-medium"
          size="large"
          type="primary"
          variant="outlined"
          color="danger"
          onClick={handleClose}
        >
          {t('general.close')}
        </Button>
        <Button
          className="bg-[#1d67b6] w-full rounded-[12px] h-12 text-base font-medium"
          size="large"
          type="primary"
          onClick={handleSave}
        >
          {t('general.save')}
        </Button>
        <Button
          className="bg-[#1d67b6] w-full rounded-[12px] h-12 text-base font-medium"
          size="large"
          type="primary"
          onClick={handlePaymentReserveChange}
        >
          {t('general.paymentReserveChange')}
        </Button>
      </div>
    </Form>
  );
};

export default BinderClaimsActions;
